import { atom } from "jotai";
import { DialogData } from "@/model";

const dialogDataAtom = atom<DialogData | null>(null);

export default dialogDataAtom;
